import { IS_HOYA_THEME, IS_SEIKO_THEME } from '../branding';

/* Use this file only for the rare instance where inline brand styling is required */
const inlineSeiko = `
body, p, h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    font-family: inherit !important;
}

h5,
.nitro-trophy-widget .latest-trophy figure figcaption .latest-earned,
.points,
.completed-text .highlighted-item,
.leaderboard .grid-x .cell,
.leaderboard-profile-section .name
{
    color: #000;
}

h3, p,
.description,
.nitro-trophy-widget button figcaption,
.challenge-card .card-title,
.leaderboard-profile-section .value
{
    color: #313131; 
}

.widget-header h3 {
    text-transform: uppercase;
}

div,
.filters .filter:not(.active) {
    background-color: #fff;
}

header div {
    background-color: #000;
}

.tabs .tab-titles a.title.active,
.filters .filter {
    color: #D28C00;
    border-color: #D28C00;
}

.level-progress-bar line {
    stroke: #c8c8c8;
}

div.nitro-widget {
    border: 1px solid #707070;
}

#level-section .level-progress-bar svg #progress-value,
#level-section .level-progress-bar svg #progress-waypoint {
    stroke: #D28C00;
}

.grid-row, .card, .trophy-container section {
    border: none;
    border-bottom: 2px dotted #707070;
}


.nitro-trophy-widget .trophy-date {
    color: #6d6d6d;
}

.card-stack {
    border-top: 2px dotted #707070;
}

.points-text .point-category {
    color: #757575;
}

.leaderboard-profile-section {
    border-top: 2px dotted #707070;
}

#level-section .level-progress-bar svg #progress-waypoint {
    fill: #D28C00;
}
`;

const inlineHoya = `

body, p, h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    font-family: inherit;
}

h5,
.nitro-trophy-widget .latest-trophy figure figcaption .latest-earned,
.points,
.completed-text .highlighted-item,
.leaderboard .grid-x .cell,
.leaderboard-profile-section .name
{
    color: #0056C4;
}

h3, p,
.description,
.nitro-trophy-widget button figcaption,
.challenge-card .card-title,
.leaderboard-profile-section .value
{
    color: #313131; 
}

div,
.filters .filter:not(.active) {
    background-color: #F6F6F4;
}

header div {
    background-color: #0056C4;
}


.level-progress-bar line {
    stroke: #c8c8c8;
}

#level-section .level-progress-bar svg #progress-value,
#level-section .level-progress-bar svg #progress-waypoint {
    stroke: #0056C4;
}

.grid-row, .card, .trophy-container section {
    border: none;
    border-bottom: 2px dotted #707070;
}


.nitro-trophy-widget .trophy-date {
    color: #6d6d6d;
}

.card-stack {
    border-top: 2px dotted #707070;
}

.points-text .point-category {
    color: #757575;
}

.leaderboard-profile-section {
    border-top: 2px dotted #707070;
}

#level-section .level-progress-bar svg #progress-waypoint {
    fill: #0056C4;
}

.nitro-trophy-widget .trophy-detail,
#labels-container,
#labels-container .label-stack .label-item {
    background-color: #F6F6F4;
}
`;

export const getInlineStyle = () => 
    IS_SEIKO_THEME ? inlineSeiko
        : IS_HOYA_THEME ? inlineHoya
        : '';